import React from 'react';
import { formatDistanceToNow } from 'date-fns';

interface AutoSaveStatusProps {
  lastSaved: Date | null;
  isSaving: boolean;
  error: string | null;
}

export const AutoSaveStatus: React.FC<AutoSaveStatusProps> = ({
  lastSaved,
  isSaving,
  error
}) => {
  if (error) {
    return (
      <div className="text-sm text-red-500 dark:text-red-400">
        Auto-save failed: {error}
      </div>
    );
  }

  if (isSaving) {
    return (
      <div className="text-sm text-gray-500 dark:text-gray-400 animate-pulse">
        Saving...
      </div>
    );
  }

  if (lastSaved) {
    return (
      <div className="text-sm text-gray-500 dark:text-gray-400">
        Draft saved {formatDistanceToNow(lastSaved, { addSuffix: true })}
      </div>
    );
  }

  return null;
}; 